(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    // MIMOYA : mesure la colonne galerie (fixe au défilement) pour la caler en bas de l'écran
    // quand elle est plus haute que lui. Voir la règle .mimoya-sticky-fit du stylesheet.
    // Perf : la règle ne s'applique qu'au-dessus de 750 px, donc pas de mesure sur mobile.
    var desktop = window.matchMedia('(min-width: 751px)');
    function fit() {
      if (!desktop.matches) return;
      document.querySelectorAll('.product-media-gallery--sticky-fit').forEach(function (gallery) {
        var col = gallery.closest('.product-section__medias');
        if (!col) return;
        col.classList.add('mimoya-sticky-fit');
        var measure = function () {
          col.style.setProperty('--mimoya-medias-h', col.offsetHeight + 'px');
        };
        measure();
        if (!col.mimoyaFitObserver && 'ResizeObserver' in window) {
          col.mimoyaFitObserver = new ResizeObserver(measure);
          col.mimoyaFitObserver.observe(col);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fit);
    } else {
      fit();
    }
    document.addEventListener('shopify:section:load', fit);
    if (desktop.addEventListener) desktop.addEventListener('change', fit);
  })();

  (function () {
    // MIMOYA perf : les photos de la galerie au-delà des premières arrivent sans source
    // (data-pmg-src / data-pmg-srcset, voir la boucle du bloc). On pose les sources au premier geste
    // du visiteur (toucher, clic, souris, molette, clavier, focus) ou 3 s après la fin du chargement :
    // le téléphone ne les télécharge plus pendant l'ouverture de la page. Elles gardent
    // loading="lazy" : le navigateur ne prend que celles proches de l'écran, les autres au swipe.
    if (window.mimoyaPmgDeferInit) return;
    window.mimoyaPmgDeferInit = true;

    var started = false;
    var events = ['pointerdown', 'touchstart', 'mousemove', 'wheel', 'keydown', 'focusin'];

    function restore(root) {
      if (!root || root.nodeType !== 1) return;
      var imgs = root.matches('img[data-pmg-src]') ? [root] : root.querySelectorAll('img[data-pmg-src]');
      Array.prototype.forEach.call(imgs, function (img) {
        var srcset = img.getAttribute('data-pmg-srcset');
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('src', img.getAttribute('data-pmg-src'));
        img.removeAttribute('data-pmg-srcset');
        img.removeAttribute('data-pmg-src');
      });
    }

    function start() {
      if (started) return;
      started = true;
      events.forEach(function (name) {
        window.removeEventListener(name, start, true);
      });
      restore(document.documentElement);
      // Galerie reconstruite ensuite (changement de variante, fenêtre d'ajout rapide) : sources posées
      // directement.
      if ('MutationObserver' in window) {
        new MutationObserver(function (records) {
          records.forEach(function (record) {
            Array.prototype.forEach.call(record.addedNodes, restore);
          });
        }).observe(document.documentElement, { childList: true, subtree: true });
      }
    }

    events.forEach(function (name) {
      window.addEventListener(name, start, { capture: true, passive: true });
    });
    var later = function () {
      setTimeout(start, 3000);
    };
    if (document.readyState === 'complete') {
      later();
    } else {
      window.addEventListener('load', later);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mimoya-bundle-gifts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mimoya-bundle-gifts')) {
    class MimoyaBundleGifts extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('form') || this.closest('product-form') || document;
        this.sync = this.sync.bind(this);
        document.addEventListener('quantity-breaks:updated', this.sync);
        const breaks = this.scope.querySelector('quantity-breaks');
        if (breaks && 'MutationObserver' in window) {
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(breaks, { subtree: true, attributes: true, attributeFilter: ['class'] });
        }
        if (this.dataset.clickUnlock === 'true') {
          this.onGiftActivate = this.onGiftActivate.bind(this);
          this.addEventListener('click', this.onGiftActivate);
          this.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            if (!event.target.closest('.mbg__gift[data-clickable]')) return;
            event.preventDefault();
            this.onGiftActivate(event);
          });
        }
        this.sync(true);
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('mbg--ready')));
      }

      // Clic sur un cadeau verrouillé : sélectionne la plus petite offre qui le débloque
      // (le bloc Quantity breaks fait le reste : prix du bouton, cadeaux, panier).
      onGiftActivate(event) {
        const gift = event.target.closest('.mbg__gift');
        if (!gift || !this.contains(gift)) return;
        const unlock = parseInt(gift.dataset.unlock || '0', 10);
        const qty = parseInt(this.dataset.qty || '0', 10);
        if (!unlock || qty >= unlock) return;
        const target = [...this.scope.querySelectorAll('quantity-break-item[data-quantity]')]
          .filter((item) => !item.classList.contains('quantity-break--disabled'))
          .map((item) => ({ item, quantity: parseInt(item.dataset.quantity, 10) }))
          .filter(({ quantity }) => quantity >= unlock)
          .sort((a, b) => a.quantity - b.quantity)[0];
        if (target) target.item.click();
      }

      // Cadeaux verrouillés marqués comme boutons (curseur, clavier, lecteurs d'écran)
      markClickable(qty) {
        if (this.dataset.clickUnlock !== 'true') return;
        this.querySelectorAll('.mbg__gift').forEach((gift) => {
          const locked = qty < parseInt(gift.dataset.unlock || '99', 10);
          const title = (gift.querySelector('.mbg__title') || {}).textContent || '';
          gift.toggleAttribute('data-clickable', locked);
          if (locked) {
            gift.setAttribute('role', 'button');
            gift.setAttribute('tabindex', '0');
            gift.setAttribute('aria-label', ('Unlock ' + title).trim());
          } else {
            gift.removeAttribute('role');
            gift.removeAttribute('tabindex');
            gift.removeAttribute('aria-label');
          }
        });
      }

      disconnectedCallback() {
        document.removeEventListener('quantity-breaks:updated', this.sync);
        if (this.observer) this.observer.disconnect();
      }

      sync(initial) {
        const selected = this.scope.querySelector('.quantity-break--selected[data-quantity]');
        const qty = selected ? parseInt(selected.dataset.quantity, 10) : parseInt(this.dataset.defaultQty || '1', 10);
        if (qty) this.markClickable(qty);
        if (!qty || String(qty) === this.dataset.qty) return;
        this.dataset.qty = String(qty);
        if (initial === true) return;
        const live = this.querySelector('[data-ref="mbg-live"]');
        if (!live) return;
        const unlocked = [...this.querySelectorAll('.mbg__gift')]
          .filter((gift) => qty >= parseInt(gift.dataset.unlock || '99', 10))
          .map((gift) => (gift.querySelector('.mbg__title') || {}).textContent)
          .filter(Boolean);
        live.textContent = unlocked.length ? 'Unlocked: ' + unlocked.join(', ') : '';
      }
    }

    customElements.define('mimoya-bundle-gifts', MimoyaBundleGifts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mimoya-savings"] && !Shopify.designMode) return;
  try {
    (function () {
    var ATTR_PRICE = 'data-total-price';
    var ATTR_COMPARE = 'data-total-compare-at-price';
    var observed = new WeakSet();

    function readConfig() {
      var el = document.querySelector('[data-mimoya-savings]');
      return el ? el.dataset : null;
    }

    function money(cents, cfg) {
      var value = cents / 100;
      var digits = cents % 100 === 0 ? 0 : 2;
      try {
        return new Intl.NumberFormat(cfg.locale || 'en', {
          style: 'currency',
          currency: cfg.currency || 'USD',
          minimumFractionDigits: digits,
          maximumFractionDigits: digits
        }).format(value);
      } catch (e) {
        return value.toFixed(digits);
      }
    }

    function target(item, placement) {
      if (placement === 'next_to_title') {
        return item.querySelector('.quantity-break__title-and-badge-container');
      }
      return item.querySelector('.quantity-break__price-container');
    }

    function paint(item, cfg) {
      var priceAttr = item.getAttribute(ATTR_PRICE);
      var compareAttr = item.getAttribute(ATTR_COMPARE);
      if (priceAttr === null || compareAttr === null) return;

      var price = parseInt(priceAttr, 10);
      var compare = parseInt(compareAttr, 10);
      if (isNaN(price) || isNaN(compare)) return;

      var saving = compare - price;
      var host = target(item, cfg.placement);
      if (!host) return;

      var el = item.querySelector('.mimoya-savings');

      if (saving <= 0 && cfg.hideZero === '1') {
        if (el) el.remove();
        return;
      }

      if (!el) {
        el = document.createElement('span');
        el.className = 'mimoya-savings mimoya-savings--' + (cfg.display || 'badge');
        if (cfg.showOn === 'desktop_only') el.classList.add('mobile-hide');
        if (cfg.showOn === 'mobile_only') el.classList.add('desktop-hide');
        el.style.color = cfg.color;
        el.style.fontSize = cfg.size + 'px';
        el.style.fontWeight = cfg.weight;
        el.style.marginTop = cfg.gap + 'px';
        if (cfg.display === 'badge') {
          el.style.background = cfg.bg;
          el.style.borderRadius = cfg.radius + 'px';
        }
        host.appendChild(el);
      }

      var parts = [];
      if (cfg.label) parts.push(cfg.label);
      parts.push(money(saving, cfg));
      if (cfg.suffix) parts.push(cfg.suffix);
      el.textContent = parts.join(' ');
    }

    function watch(item, cfg) {
      if (observed.has(item)) return;
      observed.add(item);
      new MutationObserver(function () {
        paint(item, cfg);
      }).observe(item, { attributes: true, attributeFilter: [ATTR_PRICE, ATTR_COMPARE] });
    }

    function run() {
      var cfg = readConfig();
      if (!cfg) return;
      document.querySelectorAll('[data-ref="quantity-break-item"]').forEach(function (item) {
        paint(item, cfg);
        watch(item, cfg);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('variant:updated', run);
    document.addEventListener('variantUpdated', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mimoya-testimonial"] && !Shopify.designMode) return;
  try {
    (function () {
    var MQ = '(min-width: 750.02px)';

    function place() {
      document.querySelectorAll('[data-mimoya-testimonial-move]').forEach(function (host) {
        var section = host.closest('.shopify-section-product-section');
        if (!section) return;
        var gallery = section.querySelector('.product-section__medias');
        var info = section.querySelector('[data-ref="product-section-product-info"]');
        if (!gallery || !info) return;

        if (!host.dataset.mimoyaHome) {
          host.dataset.mimoyaHome = '1';
        }

        if (window.matchMedia(MQ).matches) {
          if (host.parentNode !== gallery) gallery.appendChild(host);
          gallery.classList.remove('product-section__medias--sticky');
        } else if (host.parentNode !== info) {
          info.appendChild(host);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', place);
    } else {
      place();
    }
    window.addEventListener('resize', place);
    document.addEventListener('shopify:section:load', place);
  })();
  } catch(e) { console.error(e); }
})();

})();
